<script setup lang="ts">
import { ArrowBack } from "@vicons/ionicons5"

const router = useRouter()

function handleBack() {
    router.push("/diy")
}
</script>

<template>
    <NLayout position="absolute">
        <NLayoutHeader style="height: 50px" bordered>
            <NPageHeader class="header" @back="handleBack">
                <template #back>
                    <NButton text>
                        <template #icon>
                            <NIcon>
                                <ArrowBack />
                            </NIcon>
                        </template>
                        返回
                    </NButton>
                </template>
            </NPageHeader>
        </NLayoutHeader>
        <NLayout has-sider position="absolute" style="top: 50px">
            <LayoutConfigSider />
            <NLayout embedded>
                <slot />
            </NLayout>
        </NLayout>
    </NLayout>
</template>

<style lang="scss" scoped>
.header {
    display: flex;
    align-items: center;
    height: 50px;
    padding: 8px 16px;
}
</style>
